import { State } from '../../types';

export const hawaii: State = {
  name: 'Hawaii',
  abbreviation: 'HI',
  terms: [
    {
      word: "Aloha",
      phonetic: "uh-LOH-ha",
      description: "A Hawaiian word meaning hello, goodbye, or love, central to Hawaiian culture.",
    },
    {
      word: 'Char Siu',
      phonetic: 'chaaa shew',
      // audioUrl: '/audio/char_siu.mp3',
      description: 'A Cantonese dish often mispronounced with an audible "r."'
    },
    {
      word: 'Haʻikū',
      phonetic: 'ha-ee-KOO',
      // audioUrl: '/audio/haiku.mp3',
      description: 'A town on Maui, pronounced "ha-ee-KOO," not "hai-koo."'
    },
    {
      word: 'Haleakalā',
      phonetic: 'hah-leh-ah-kah-LAH',
      // audioUrl: '/audio/haleakala.mp3',
      description: 'A National Park often mispronounced as "hah-leh-AH-ka-lah."'
    },
    {
      word: 'Hanalei',
      phonetic: 'hah-nah-LAY',
      // audioUrl: '/audio/hanalei.mp3',
      description: 'A town on Kauaʻi, pronounced "hah-nah-LAY," not "han-uh-lee."'
    },
    {
      word: 'Hanauma Bay',
      phonetic: 'ha-now-mah',
      // audioUrl: '/audio/hanauma_bay.mp3',
      description: 'Popular bay often mispronounced by visitors.'
    },
    {
      word: 'Hawaii',
      phonetic: 'huh-VAI-ee',
      // audioUrl: '/audio/hawaii.mp3',
      description: 'State name pronunciation (traditional)'
    },
    {
      word: 'Honolulu',
      phonetic: 'hoh-noh-LOO-loo',
      // audioUrl: '/audio/honolulu.mp3',
      description: 'The capital city, pronounced "hoh-noh-LOO-loo," not "hahn-uh-loo-loo."'
    },
    {
      word: "Hula",
      phonetic: "HOO-lah",
      description: "A traditional Hawaiian dance that tells stories through movement and chant.",
    },
    {
      word: 'Humuhumunukunukuāpuaʻa',
      phonetic: 'hoo-moo-hoo-moo-noo-koo-noo-koo-ah-poo-ah-ah',
      // audioUrl: '/audio/humuhumu.mp3',
      description: 'Hawaii’s state fish, the "fish with a nose like a pig."'
    },
    {
      word: 'ʻEwa',
      phonetic: 'eh-va',
      // audioUrl: '/audio/ewa.mp3',
      description: 'An Oʻahu district often mispronounced as "Ee-wa."'
    },
    {
      word: 'Kailua',
      phonetic: 'kai-LOO-ah',
      // audioUrl: '/audio/kailua.mp3',
      description: 'A town on Oʻahu, pronounced "kai-LOO-ah," not "kay-loo-ah."'
    },
    {
      word: 'Kāneʻohe',
      phonetic: 'kah-neh-OH-heh',
      // audioUrl: '/audio/kaneohe.mp3',
      description: 'A town on Oʻahu, pronounced "kah-neh-OH-heh," not "kan-ee-oh-hee."'
    },
    {
      word: 'Karaoke',
      phonetic: 'ka-ra-o-ke',
      // audioUrl: '/audio/karaoke.mp3',
      description: 'Correct Japanese pronunciation of the word.'
    },
    {
      word: 'Kalākaua',
      phonetic: 'ka-LAAH-kauw-ah',
      // audioUrl: '/audio/kalakaua.mp3',
      description: 'A main thoroughfare in Waikīkī often mispronounced.'
    },
    {
      word: 'Kīlauea',
      phonetic: 'kee-lah-WAY-ah',
      // audioUrl: '/audio/kilauea.mp3',
      description: 'An active volcano, pronounced "kee-lah-WAY-ah," not "kil-uh-way-uh."'
    },
    {
      word: 'Kauai',
      phonetic: 'kuh-WAI-ee',
      // audioUrl: '/audio/kauai.mp3',
      description: 'One of the main Hawaiian islands'
    },
    {
      word: 'Lānaʻi',
      phonetic: 'la-nah-ee',
      // audioUrl: '/audio/lanai.mp3',
      description: 'The Hawaiian island.'
    },
    {
      word: 'Lānai',
      phonetic: 'lah-nai',
      // audioUrl: '/audio/lanai_veranda.mp3',
      description: 'A porch or veranda.'
    },
    {
      word: 'Likelike',
      phonetic: 'lee-kay-lee-kay',
      // audioUrl: '/audio/likelike.mp3',
      description: 'Often mispronounced as "Like Like" by visitors.'
    },
    {
      word: 'Lychee',
      phonetic: 'lie-chee',
      // audioUrl: '/audio/lychee.mp3',
      description: 'Preferred pronunciation in Hawaii.'
    },
    {
      word: 'Molokaʻi',
      phonetic: 'MO-loh-kai',
      description: 'An island known for its unspoiled beauty and connection to Hawaiian traditions.'
    },
    {
      word: 'Nānākuli',
      phonetic: 'nah-nah-KOO-lee',
      // audioUrl: '/audio/nanakuli.mp3',
      description: 'A town on Oʻahu, pronounced "nah-nah-KOO-lee," not "nan-uh-koo-lee."'
    },
    {
      word: "ʻOhana",
      phonetic: "oh-HAH-nah",
      description: "Family, including extended and chosen family, central to Hawaiian values.",
    },
    {
      word: 'Puʻuhonua',
      phonetic: 'poo-oo-HO-noo-ah',
      description: 'An ancient place of refuge on the Big Island of Hawaii.'
    },
    {
      word: 'Temperature',
      phonetic: 'tempa-chur',
      // audioUrl: '/audio/temperature.mp3',
      description: 'Simplified pronunciation used by locals.'
    },
    {
      word: 'Three',
      phonetic: 'tree',
      // audioUrl: '/audio/three.mp3',
      description: 'Common mispronunciation in the Islands.'
    },
    {
      word: 'Wahiawā',
      phonetic: 'wa-hee-a-wa',
      // audioUrl: '/audio/wahiawa.mp3',
      description: 'Often mispronounced as "Wa-hee-wa."'
    },
    {
      word: 'Waiʻanae',
      phonetic: 'wai-ah-NAI',
      // audioUrl: '/audio/waianae.mp3',
      description: 'A town on Oʻahu, pronounced "wai-ah-NAI," not "wai-an-ee."'
    },
    {
      word: 'Wailuku',
      phonetic: 'wai-LOO-koo',
      // audioUrl: '/audio/wailuku.mp3',
      description: 'A town on Maui, pronounced "wai-LOO-koo," not "wai-luh-koo."'
    },
    {
      word: 'Waimea',
      phonetic: 'wai-MAY-ah',
      // audioUrl: '/audio/waimea.mp3',
      description: 'Towns on multiple islands, pronounced "wai-MAY-ah," not "wai-mee-uh."'
    }
  ]
};